module.exports = __webpack_public_path__ + "media/application/images/icons/icon-checkmark-c864cf265dc4822aed637265e33094c1.svg";